import axios from 'axios';
import API_CONFIG from '../config/api';
import { translateVi } from '../i18n/LocaleContext';

const API_URL = API_CONFIG.getApiUrl('/kyc');

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

export const kycService = {
  getStatus: async () => {
    try {
      const response = await axios.get(API_URL, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không tải được trạng thái xác minh'));
    }
  },

  submit: async ({ realName, phone, front, back }) => {
    try {
      const form = new FormData();
      form.append('real_name', realName);
      form.append('phone', phone);
      form.append('front', front);
      form.append('back', back);
      const token = localStorage.getItem('token');
      const response = await axios.post(API_URL, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      const err = new Error(error.response?.data?.error || translateVi('Gửi xác minh thất bại'));
      err.errorCode = error.response?.data?.errorCode;
      throw err;
    }
  }
};
